import Cycled from 'cycled'
import random from 'just-random-integer'

const colors = {
  'cmoa-orchid': 'rgb(200, 55, 255)',
  'cmoa-sea-green': 'rgb(0, 180, 130)',
  'cmoa-neon-pink': 'rgb(255, 65, 255)',
  'cmoa-yellow': 'rgb(255, 255, 0)',
  'cmoa-brown': 'rgb(160, 115, 40)',
  'cmoa-lavender': 'rgb(160, 130, 255)',
  'cmoa-red': 'rgb(255, 65, 0)',
  'cmoa-bubblegum-pink': 'rgb(255, 105, 180)',
  'cmoa-mint': 'rgb(0, 255, 135)',
  'cmoa-amethyst': 'rgb(160, 110, 225)',
  'cmoa-lime': 'rgb(195, 255, 0)',
  'cmoa-powder-blue': 'rgb(50, 170, 255)',
  'cmoa-rose': 'rgb(255, 105, 135)',
  'cmoa-orange': 'rgb(255, 110, 0)',
  'cmoa-sky-blue': 'rgb(0, 220, 255)',
  'cmoa-pink': 'rgb(255, 120, 255)',
  'cmoa-neon-green': 'rgb(0, 255, 50)',
}

const colorNames = Object.keys(colors)

const colorGenerator = new Cycled(colorNames)
colorGenerator.index = random(colorNames.length - 1)

export { colors as default, colorGenerator }
